import React, { FC } from 'react';
import { PaymentRegionModal } from '@pisaka/ui';
import { useModal } from '../../../../hooks/useModal';
import { useSelector } from 'react-redux';
import { AppStateTypes } from '../../../../store/appStateTypes';
import { PAYMENT_MODAL_NAME } from '../../../../constants/modalNamesConstants';
import { usePayFont, useGetFonts } from '../font/useFonts';
import { useLavaInvoice } from '../../../payment/useLavaInvoice';
import { socket } from '../../../../helpers/socket';
import { useTranslation } from 'react-i18next';

const FONT_PRICE_RUB = 199;
const FONT_PRICE_USD = 5;

const PaymentModalContainer: FC = () => {
  const { t } = useTranslation();
  const { isOpenModal, onCloseModal, payload } = useModal(PAYMENT_MODAL_NAME);
  const { fontId } = payload;

  const { payFont } = usePayFont();
  const { loadingFonts } = useGetFonts();
  const { openPayment, isLoading: isLavaLoading } = useLavaInvoice();
  const { user } = useSelector((state: AppStateTypes) => state.auth) || {};
  const isWorldEnabled = Number(user?.id) === 1;

  const handleSelectRussia = async () => {
    onCloseModal();
    const { paymentConfirmationToken, status, paymentId } = await payFont(fontId) || {};

    if (paymentConfirmationToken && paymentId) {
      const handlePaymentSuccess = async () => {
        await loadingFonts();
        socket.off(`payment:${paymentId}`, handlePaymentSuccess);
      };

      socket.on(`payment:${paymentId}`, handlePaymentSuccess);

      // @ts-ignore
      const checkout = new window.YooMoneyCheckoutWidget({
        confirmation_token: paymentConfirmationToken,
        customization: { modal: true },
        error_callback() {},
      });

      checkout.render();
      checkout.on('success', () => { checkout.destroy(); handlePaymentSuccess(); });
      checkout.on('fail', () => { socket.off(`payment:${paymentId}`, handlePaymentSuccess); checkout.destroy(); });
    }

    if (status === 'succeeded') {
      await loadingFonts();
    }
  };

  const handleSelectWorld = async () => {
    await openPayment(
      { type: 'font_purchase', fontId: String(fontId), returnUrl: window.location.pathname },
      async () => { await loadingFonts(); },
    );
  };

  const regionModalTexts = {
    title:          t('paymentRegion.title'),
    russiaTitle:    t('paymentRegion.russiaTitle'),
    russiaSubtitle: t('paymentRegion.russiaSubtitle'),
    worldTitle:     t('paymentRegion.worldTitle'),
    worldSubtitle:  t('paymentRegion.worldSubtitle'),
    or:             t('paymentRegion.or'),
  };

  return (
    <PaymentRegionModal
      isOpen={isOpenModal}
      onClose={onCloseModal}
      onSelectRussia={handleSelectRussia}
      onSelectWorld={handleSelectWorld}
      planName={t('payment.fontPurchase')}
      priceRub={FONT_PRICE_RUB}
      priceUsd={FONT_PRICE_USD}
      texts={regionModalTexts}
      isWorldLoading={isLavaLoading}
      isWorldEnabled={isWorldEnabled}
    />
  );
};

export default PaymentModalContainer;
